import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
    getPortfolioSummarySuccess,
    getPortfolioSummaryError,
    AddMoneySuccess,
    AddMoneyError,
    withdrawMoneySuccess,
    withdrawMoneyError,
    getReferEarnSuccess, getReferEarnError, getInvestmentSummarySuccess, getInvestmentSummaryError, getCashLedgerSuccess, getCashLedgerError, fetchBorrowerDetailsSuccess, fetchBorrowerDetailsError
} from './dashboardAction';
import { ADD_MONEY, PORTFOLIO_SUMMARY_REQUEST, INVESTMENT_SUMMARY_REQUEST, REFER_EARN_REQUEST, WITHDRAW_MONEY, CASH_LEDGER_REQUEST, FETCH_BORROWER_DETAILS } from './actionsTypes';
import { ADD_MONEY_URL, API, GET_REFERRAL_CODE_URL, PORTFOLIO, INVESTMENT_SUMMARY, CASH_LEDGER, WITHDRAW_MONEY_URL, GATEWAY_MONEY_URL, LLAPIURL, GET_BORROWER_URL } from '../../../utils/urls';
import {  fetchGet, fetchPost } from '../../../utils/request';

const stateInvestFund = (state: any) => state.investFund;

function* getDashboardSummary(): any {
    try {
        const response = yield call(fetchGet, PORTFOLIO); 
        if (response.error) {
            if (response.error.status === false) {
                yield put(getPortfolioSummarySuccess(response.error));
                return true
            } else {
                yield put(getPortfolioSummaryError(response.error.message))
                return false;
            }
        }
        yield put(getPortfolioSummarySuccess(response.results));
        return true;
    } catch (error) {
        yield put(getPortfolioSummaryError(error));
    }
}

function* getInvestmentSummary(): any {
    try {
        const response = yield call(fetchGet, INVESTMENT_SUMMARY);
        if (response.error) {
            if (response.error.status === false) {
                yield put(getInvestmentSummarySuccess(response.error));
                return true;
            } else {
                yield put(getInvestmentSummaryError(response.error));
                return false;
            }
        }
        yield put(getInvestmentSummarySuccess(response.results)) // when got the 
    } catch (error: any) {
        yield put(getInvestmentSummaryError(error));
    }
}

function* getCashLedgerSummary(): any {
    try {
        const response = yield call(fetchGet, CASH_LEDGER)
        if (response.error) {
            if (response.error.status === false) {
                yield put(getCashLedgerSuccess(response.error));
                return true;
            } else {
                yield put(getCashLedgerError(response.error));
                return false;
            }
        }
        yield put(getCashLedgerSuccess(response.results));
    } catch (error:any) {
        yield put(getCashLedgerError(error))
    }
}

function* getAddMoneySummary(): any {
    const stateValue = yield select(stateInvestFund);
    let body = {
        "TransactionAmount":stateValue.addMoneyAmount
    }
    try {
        const response = yield call(fetchPost, ADD_MONEY_URL, body);
        yield put(AddMoneySuccess(response.results));
    } catch (error) {
        yield put(AddMoneyError(error))
    }
}

function* withdrawMoney(): any {
    const stateValue = yield select(stateInvestFund);
    try {
        const body = {
            "TransactionAmount":stateValue.addMoneyAmount
        }
        const response = yield call(fetchPost, WITHDRAW_MONEY_URL, body);
        if (response.error) {
            yield put(withdrawMoneyError(response.error.message));
            return false;
        }
        if (response.status) {
            yield put(withdrawMoneySuccess(response));
            return true;
        }

    } catch (error) {
        yield put(withdrawMoneyError(error))
    }
}

function* getReferEarn(): any {
    try {
        const response = yield call(fetchGet, GET_REFERRAL_CODE_URL);
        if (response.status) {
            yield put(getReferEarnSuccess(response.results));
            return true
        } else {
            yield put(getReferEarnError(response.error?.errors?.detail))
            return true
        }

    } catch (error) {
        yield put(getReferEarnError(error))
    }
}

function* fetchBorrowerSummary():any {
    try {
        const response = yield call(fetchGet, GET_BORROWER_URL);
        if(response.error){
            if(response.error.status === false){
                yield put(fetchBorrowerDetailsSuccess(response.results));
                return true;
            } else {
                yield put(fetchBorrowerDetailsError(response.error?.errors?.detail))
                return true
            }
        }
        yield put(fetchBorrowerDetailsSuccess(response.results)); 

    } catch (error) {
        yield put(fetchBorrowerDetailsError(error));
    }
}

export default function* dashboardSaga() {
    yield all([
        takeLatest(PORTFOLIO_SUMMARY_REQUEST, getDashboardSummary),
        takeLatest(INVESTMENT_SUMMARY_REQUEST, getInvestmentSummary),
        takeLatest(CASH_LEDGER_REQUEST, getCashLedgerSummary),
        takeLatest(ADD_MONEY, getAddMoneySummary),
        takeLatest(REFER_EARN_REQUEST, getReferEarn),
        takeLatest(WITHDRAW_MONEY, withdrawMoney),
        takeLatest(FETCH_BORROWER_DETAILS, fetchBorrowerSummary)
    ])
}